const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const PHONE_REGEX =
  /^((\+?[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const PASSWORD_REGEX = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

const UPPERCASE_REGEX = /(?=.*?[A-Z])/;

const LOWERCASE_REGEX = /(?=.*?[a-z])/;

const NUMBER_REGEX = /(?=.*?[0-9])/;

const SPECIAL_CHAR_REGEX = /(?=.*?[#?!@$%^&*-])/;

const ATLEAST_EIGHT_CHAR_REGEX = /.{8,}$/;

export const validateString = (string: string, pattern: string | RegExp) => {
  return new RegExp(pattern).test(string);
};

export {
  EMAIL_REGEX,
  PHONE_REGEX,
  PASSWORD_REGEX,
  UPPERCASE_REGEX,
  LOWERCASE_REGEX,
  NUMBER_REGEX,
  SPECIAL_CHAR_REGEX,
  ATLEAST_EIGHT_CHAR_REGEX,
};
